import { LegacyContentType } from "./enums";

export class LegacyContentModel {
  xmlContent = '';
  legacyContentType: LegacyContentType;
}